module.exports = __webpack_public_path__ + "static/media/3.fe0e98ca.jpg";